module.exports = __webpack_public_path__ + "img/06.27e6a8ed.jpg";